export default "/build/images/alqassim.png?a373df68d325209572f61574e47db0ea";